import {scaleLinear} from '@visx/scale';
import {parseISO} from 'date-fns';

import {DeltaTrendChartData} from './DeltaTrendChart.types';

export const getX = ({registeredDate}: DeltaTrendChartData) => parseISO(registeredDate);
export const getY = ({deltaAge}: DeltaTrendChartData) => deltaAge;

/**
 * Given the scale of the Y axis, this function returns the specific
 * tick values that should be drawn as gridlines on the chart.
 */
export const getGridYTicks = (yScale: ReturnType<typeof scaleLinear>) => {
  const [min, max] = yScale.domain();

  return [min, min / 2, 0, max / 2, max];
};

/**
 * Given the scale of the Y axis, this function returns the specific tick
 * values that should be drawn as labels on the chart. Only the max, min, and
 * exact mid-point (ie, `0`) should be labelled.
 */
export const getAxisYTicks = (yScale: ReturnType<typeof scaleLinear>) => {
  return [yScale.domain()[0], 0, yScale.domain()[1]];
};

/**
 * Given the array of deltaAges to be charted, this function determines the
 * domain of the chart. The largest absolute deltaAge from the data is found,
 * and then rounded up to the nearest whole year value. The domain of the chart
 * then ranges from the negative of that number, to the positive.
 */
export const getYScaleDomain = (data: DeltaTrendChartData[] = []) => {
  const isEmpty = data?.length <= 0;
  const largestDelta = isEmpty ? 60 : Math.max(...data.map(({deltaAge}) => Math.abs(deltaAge)));

  // Round up to the next whole year value.
  const nextLargestWholeYear = Math.ceil(largestDelta / 12) * 12;

  return [-nextLargestWholeYear, nextLargestWholeYear];
};
